@if (audio) {
    <sew-ws-reader
        [buttonText]="labels?.CMS_AUDIO_TOGGLE ?? ''"
        [playText]="labels?.CMS_AUDIO_PLAY ?? ''"
        [pauseText]="labels?.CMS_AUDIO_PAUSE ?? ''"
        [stopText]="labels?.CMS_AUDIO_STOP ?? ''"
        [rewindText]="labels?.CMS_AUDIO_REWIND ?? ''"
        [forwardText]="labels?.CMS_AUDIO_FORWARD ?? ''"
        [volumeText]="labels?.CMS_AUDIO_VOLUME ?? ''"
        [speedText]="labels?.CMS_AUDIO_SPEED ?? ''"
        [closeText]="labels?.CMS_GENERAL_CLOSE ?? ''"
    >
        <audio slot="audio" [src]="audio.audio_src"></audio>
    </sew-ws-reader>
}
